// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';

export default function MauText() {
  return (
    <React.Fragment>
      {i18n._('300 million', '[m10n] number of monthly active users on pinterest')}
    </React.Fragment>
  );
}
